export default __webpack_public_path__ + "static/media/RepeatGrid1.bfaf4df1.png";